import React,{ useState }  from 'react';
import {Segment,Grid, Button,Form} from 'semantic-ui-react'
import {useCheckForm} from '@wollo-lib/wollo-react'
import {SearchSelect} from '@wollo-lib/wollo-react' //'../SearchSelect' // //
import {v1 as uuid} from 'uuid'


const EditUser=({db,user,setUser,afterSubmit,deleteUser, close})=>
{

    const mailRegEx=/^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    const telRegEx=/^\+(?:[0-9] ?){6,14}[0-9]$/

    const testValidRegEx=(val,regex,empty)=>
    (
            val ? 
                val.match(regex)
            :
                empty
    )
    

    const usersDB= db.users



    const submit=async ()=>
    {
           
        if(!checkSubmit)
            return
    
   
        const result=await usersDB.put(user)
        .catch(
                (e)=>console.log('error Dexi put users:',user,e)
            )
        console.log(result)
        afterSubmit()
    }
        
    const handleChange=(e,{name,value, result})=>
    {
        if(name==='PLZOrt')
        {
            if(result)
            {
                setUser(u=>({...u,
                    Ort:result.Ort,
                    PLZ:result.PLZ,
                    Land:result.Land,
                    IOrt:result.IOrt
                }))
            }
            else
            {
                setUser(u=>({...u,Ort:value,IOrt:null, PLZ: null, Land:'CH'}))
            }
        }
        else
        {
            setUser(u=>({...u,[name]:value}))
        }
    }
   

   const {errors,checkSubmit,hasError}= useCheckForm(user,
        [
          {name:'Vorname',error:'Vorname muss angegeben werden',test:((val)=>(val!==''))},  
          {name:'Nachname',error:'Nachname muss angegeben werden',test:((val)=>(val!==''))},
          {name:'email',error:'ungültiges E-Mail Adressformat', test:((val)=> testValidRegEx(val,mailRegEx,true))},
          {name: 'mobil', error:'Nummer muss im internationalen Format mit +41 usw angegeben werden', test:((val)=>testValidRegEx(val,telRegEx,true))},
          {name: 'Festnetz', error:'Nummer muss im internationalen Format mit +41 usw angegeben werden', test:((val)=>testValidRegEx(val,telRegEx,true))}
        ]
    )

    return(
      <Segment>
            <Form autocomplete={uuid()}>
                <Grid>
                    <Grid.Column key={1} width={8}>
                        <Form.Input
                            label={'Vorn'+String.fromCharCode(8203)+'ame'}
                            placeholder={'Vorn'+String.fromCharCode(8203)+'ame'}
                            value={user.Vorname}
                            onChange={handleChange}
                            name='Vorname'
                        />
                    </Grid.Column>
                    <Grid.Column key={2} width={8}>
                        <Form.Input
                            label={'Nach'+String.fromCharCode(8203)+'ame'}
                            placeholder={'Nach'+String.fromCharCode(8203)+'ame'}
                            value={user.Nachname}
                            onChange={handleChange}
                            name='Nachname'
                        />
                    </Grid.Column>
                </Grid>
   
                <Form.Input
                    label='Adresse 1'
                    placeholder={'Stras'+String.fromCharCode(8203)+'se'}
                    value={user.Strasse}
                    onChange={handleChange}
                    name='Strasse'
                />
                <Form.Input
                    label='Adresse 2'
                    placeholder={'Stra'+String.fromCharCode(8203)+'sse/Zusatz'}
                    value={user.Strasse2}
                    onChange={handleChange}
                    name='Strasse2'
                />
                <Form.Field
                    label='Postleitzahl, Ort *'
                    value={(user.PLZ? user.PLZ :'')+  (user.PLZ && user.Ort ?' ':'') + (user.Ort ? user.Ort :'')} 
                    name='PLZOrt' 
                    onChange={handleChange} 
                    placeholder={'Postl'+String.fromCharCode(8203)+'eitzahl und Or'+String.fromCharCode(8203)+'t'}
                    control={SearchSelect}
                    SuggestDexie= {{
                        table: db.cities,
                        field: 'fulltext',
                        map: el=> ({
                            key:el.UID, 
                            title:`${el.PLZ} ${el.Ort}`, 
                            value: `${el.PLZ} ${el.Ort}`, 
                            Ort: el.Ort,
                            Land: el.Land,
                            PLZ: el.PLZ}),

                    }}
                    error={errors['Ort']}
                    api='base'
                    autoComplete={uuid()}
                    type='search'
               />
                <Form.Field
                    label='Land *' 
                    value={user.Land} 
                    name='Land' 
                    onChange={handleChange} 
                    placeholder={'La'+String.fromCharCode(8203)+'nd'}
                    control={SearchSelect}
                    Value2TitleUrl={{
                        table: db.countries,
                        field: 'UID',
                        map: el=>({
                            key:el.UID,
                            value: el.UID,
                            title: el.DName
                        })

                    }}
                    SuggestDexie={{
                        table: db.countries,
                        title: 'DName',
                        value: 'UID',
                        field: 'DName',
                        map: el=>({
                            key:el.UID,
                            value: el.UID,
                            title: el.DName
                        })

                    }} 
                    error={errors['Land']}
                    api='base'
                    autoComplete='nein2'

                />
            
                <Form.Input
                    label={'E-'+String.fromCharCode(8203)+'Mail'}
                    placeholder={'E-M'+String.fromCharCode(8203)+'ail Adresse'}
                    value={user.email}
                    onChange={handleChange}
                    name='email'
                    error={errors['email']}
                />
                <Form.Input
                    label={'Festnetz'+String.fromCharCode(8203)+' Telefonnummer'}
                    placeholder={'Telef'+String.fromCharCode(8203)+'on'}
                    value={user.Festnetz}
                    onChange={handleChange}
                    name='Festnetz'
                    error={errors['Festnetz']}
                />
                <Form.Input
                    label={'Mobil'+String.fromCharCode(8203)+' Telefonnummer'}
                    placeholder={'Han'+String.fromCharCode(8203)+'dy'}
                    value={user.mobil}
                    onChange={handleChange}
                    name='mobil'
                    error={errors['mobil']}
                />
                <Form.Group>
                    <Button
                        content='speichern'
                        icon='save'
                        onClick={submit}
                        color={hasError.current ? null : 'green'}
                        style={{textAlign:'right'}}
                    />

                    {
                        !close ? '':
                        <Button
                            negative
                            icon='close'
                            labelPosition='right'
                            content='Abbrechen'
                            onClick={close}
                        />
                    }
                    {
                        ! deleteUser ? '' : 
                        <Button icon='trash' content='Löschen' onClick={deleteUser}/>   
                    }
                </Form.Group>

            </Form>
        </Segment>
    )
}
export default EditUser
